import { render, staticRenderFns } from "./GraficoBoxPlotPredicao.vue?vue&type=template&id=c4181f2c&"
import script from "./GraficoBoxPlotPredicao.vue?vue&type=script&lang=js&"
export * from "./GraficoBoxPlotPredicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
